$(document).ready(function () {
    $("#checkout-form").validate({
        rules: {
            customer_phone: {
                required: true,
                phoneVN: true
            }
        },
        messages: {
            customer_phone: {
                required: "Vui lòng nhập số điện thoại.",
                phoneVN: "Vui lòng nhập số điện thoại hợp lệ."
            }
        }
    });

    $.validator.addMethod("phoneVN", function (value, element) {
        var phoneRegex = /^(0|\+84)(\s|\.)?((3[2-9])|(5[689])|(7[06-9])|(8[1-689])|(9[0-46-9]))(\d)(\s|\.)?(\d{3})(\s|\.)?(\d{3})$/;

        if (value.includes('(') && value.includes(')')) {
            value = value.replaceAll('(', '')
            value = value.replaceAll(')', '')
        }
        return this.optional(element) || phoneRegex.test(value);
    }, "Vui lòng nhập số điện thoại hợp lệ.");

    const inputVoucher = $('#inupt_voucher')
    const buttonApplyVoucher = $('#btn_apply_voucher')

    inputVoucher.on('input', function (e) {
        if ($(this).val().length > 0) {
            // console.log('active')
            buttonApplyVoucher && buttonApplyVoucher.addClass('text-color-primary')
        } else {
            // console.log('inactive')
            buttonApplyVoucher && buttonApplyVoucher.removeClass('text-color-primary')
        }
    })

    let cartFunc = {
        removeError: function () {
            $('div.alert-wrapper').html('');
        },
        showError: function (xhr) {
            this.removeError();
            //
            let messages = [];
            let responseJSON = 'responseJSON' in xhr ? xhr.responseJSON : JSON.parse(xhr.responseText);
            if ('errors' in responseJSON) {
                Object.values(responseJSON.errors).forEach(function (items) {
                    items.forEach(function (message) {
                        messages.push(message);
                    });
                });
            } else {
                messages.push(responseJSON.message);
            }

            if (messages.length < 1) {
                return;
            }
            let alertBox = `<div class="alert alert-danger" role="alert">
        <ul class="error">
        ${messages.map(function (message) {
                return `<li>${message}</li>`;
            }).join('')}
        </ul>
    </div>`;

            $('div.alert-wrapper').append(alertBox);
        },
        variantItemClick: function (eleVariant) {
            let price_format = eleVariant.data('price_format')

            const text_variant = eleVariant.text()
            let html = `${price_format} <span>(${$.trim(text_variant)})</span>`

            // $('.product-detail__detail--right__price').text(price_format);
            $('.product-detail__detail--right__price').html(html);
            $('#add-to-cart-form .atc-option').val(eleVariant.data('value'))
        },
        cartVariantItemChange: function (eleVariant) {
            let _value = eleVariant.val();


        },
        renderCartItem: function (items) {
            let html = '';

            if (Object.values(items).length < 1) {
                $('.cart__popup .cart__popup--items').html('').addClass('d-none');
                $('.cart__popup .cart__popup--empty').removeClass('d-none');
            } else {
                Object.values(items).forEach(function (item) {
                    $(`.main-cart__body--item[data-id="${item.id}"] p.price`).text(item.total.formatted)
                    html += `<div class="cart__popup--item">
                            <div class="cart__popup--item__img">
                                <a href="/${item['product']['slug']}">
                                    <img src="${item['product']['base_image']['path']}" 
                                        alt="${item['product']['base_image']['filename']}">
                                </a>
                            </div>

                            <div class="cart__popup--item__info">
                                <a href="/${item['product']['slug']}">
                                    <h4 class="hover-title">${item['product']['name']}</h4>
                                </a>
                                <p class="price">${item.total.formatted}</p>
                            </div>
                        </div>`;
                })

                $('.cart__popup .cart__popup--items').html(`${html}
            <a href="${route('cart.index')}" class="view-cart button-default button-default-hover w-full">
                Xem giỏ hàng
            </a>`).removeClass('d-none');

                $('.cart__popup .cart__popup--empty').addClass('d-none');
            }
        },
        updateInfo: function (response) {
            $('.cart-total-qty').text(response['quantity']).attr('data-qty', response['quantity']);
            $('.bill-item .product-price').text(response.subTotal.formatted);
            $('.bill-item .shipping-price').text(response.shippingCost.formatted);
            $('.bill-item .total-price').text(response.total.formatted);
        },
        addToCart: function (eleButton) {
            window.setLoading(eleButton[0], 20, 'var(--color-secondary)', false);

            let formData = new FormData(document.getElementById('add-to-cart-form'));
            let product_id = $('#add-to-cart-form [name="product_id"]').val();
            let qty = parseInt($('#add-to-cart-form [name="qty"]').val()) || 0;

            let settings = {
                "url": route('cart.items.store'),
                "method": "POST",
                "timeout": 0,
                "processData": false,
                "mimeType": "multipart/form-data",
                "contentType": false,
                "data": formData
            };

            $.ajax(settings).done(function (response) {
                cartFunc.removeError();
                window.hideLoading(eleButton[0], '', false);

                if (typeof response == 'string') {
                    response = JSON.parse(response);
                }

                cartFunc.renderCartItem(response['items']);
                cartFunc.updateInfo(response);
                cartFunc.showPopupItem(response, product_id, qty);
            }).fail( function(xhr, textStatus, errorThrown) {
                cartFunc.showError(xhr);
                window.hideLoading(eleButton[0], '', false);
                return false;
            });
        },
        showPopupItem: function (response, product_id, qty) {
            const popupAtc = document.querySelector('.popup-atc')
            if (popupAtc) {
                window.setOverlayBody()

                $('.cart__popup-noti--qty').text(qty);

                Object.values(response['items']).forEach(function (item) {
                    product_id = parseInt(product_id);

                    if (item['product']['id'] === product_id) {
                        $('.cart__popup-noti--item').html(`
                            <div class="cart__popup-noti--item__img">
                                <a href="/${item['product']['slug']}">
                                    <img src="${item['product']['base_image']['path']}" 
                                        alt="${item['product']['base_image']['filename']}">
                                </a>
                            </div>
                
                            <div class="cart__popup-noti--item__info">
                                <a href="/${item['product']['slug']}">
                                    <h4 class="hover-title">${item['product']['name']}</h4>
                                </a>
                                <p class="price">${item.total.formatted}</p>
                            </div>`
                        );
                    }
                })

                popupAtc.classList.add('active')

                setTimeout(function () {
                    popupAtc.classList.remove('active');
                    window.removeOverlayBody();
                }, 10e3);
            }
        },
        updateCartItem: function (itemId, qty, variant) {
            if (qty < 1) {
                return;
            }
            let settings = {
                "url": route('cart.items.update', itemId),
                "method": "PUT",
                "timeout": 0,
                "headers": {
                    "Content-Type": "application/json"
                },
                "data": JSON.stringify({
                    "qty": qty,
                    "variant": variant,
                }),
            };

            $.ajax(settings).done(function (response) {
                cartFunc.removeError();
                let bodyItems = $('.main-cart__body--item'), pageCartItemIds = [], responseCartItemIds = [];
                bodyItems.each(function () {
                    pageCartItemIds.push($(this).data('id'))
                });
                Object.values(response['items']).forEach(function (item) {
                    responseCartItemIds.push(item.id);
                });

                if (
                    (bodyItems.length !== Object.values(response['items']).length)
                    || JSON.stringify(pageCartItemIds.sort()) !== JSON.stringify(responseCartItemIds.sort())
                ) {
                    window.location.reload();
                }

                cartFunc.renderCartItem(response['items']);
                cartFunc.updateInfo(response);
            }).fail( function(xhr, textStatus, errorThrown) {
                cartFunc.showError(xhr);
                window.hideLoading(eleButton[0], '', false);
                return false;
            });
        },
        removeItem: function (itemId) {
            $.ajax({
                'method': 'DELETE',
                'url': route('cart.items.destroy', { cartItemId: itemId }),
                'headers': {
                    "Content-Type": "application/json"
                },
            }).done(function (response) {
                cartFunc.removeError();
                cartFunc.renderCartItem(response['items']);
                cartFunc.updateInfo(response);

                if (response['items'].length < 1) {

                    $('.card.container form').remove();
                    $('.card.container').append(`<div class="cart-empty">${CART_EMPTY}</div>`);

                    localStorage.removeItem(cartFunc.storageKey);
                } else {
                    let itemIds = Object.keys(response['items']);
                    $('.main-cart__body--item').each(function () {
                        let _id = $(this).data('id');
                        if (!itemIds.includes(_id)) {
                            $(this).remove();
                        }
                    })
                }
            }).fail( function(xhr, textStatus, errorThrown) {
                cartFunc.showError(xhr);
                window.hideLoading(eleButton[0], '', false);
                return false;
            });
        },
        cartItemChange: function (ele) {
            let wrapper = ele.closest('.main-cart__body--item'),
                itemId = wrapper.data('id'),
                qty = parseInt(wrapper.find('input').val()) || 0,
                variant = wrapper.find('.cart-variant-item').val();

            cartFunc.updateCartItem(itemId, qty, variant);
        },
        provinceChange: function (dataType) {
            let eleProvince = $('.field-province'),
                eleDistrict = $('.field-district'),
                eleWard = $('.field-ward'),
                province = eleProvince.val(),
                district = eleDistrict.val(),
                ward = eleWard.val();

            if (dataType === 'province') {
                eleDistrict.find('.option').remove();
                eleWard.find('.option').remove();
            } else {
                eleWard.find('.option').remove();
            }


            $.ajax({
                'method': 'GET',
                'url': route('checkout.province'),
                "data": {
                    "province": province,
                    "district": district,
                    "ward": ward,
                },
                'headers': {
                    "Content-Type": "application/json"
                },
            }).done(function (response) {
                cartFunc.removeError();
                if ('districts' in response) {
                    response.districts.forEach(function (value) {
                        eleDistrict.append(`<option class="option" value="${value}">${value}</option>`);
                    });
                }
                if ('wards' in response) {
                    response.wards.forEach(function (value) {
                        eleWard.append(`<option class="option" value="${value}">${value}</option>`);
                    });
                }
            }).fail( function(xhr, textStatus, errorThrown) {
                cartFunc.showError(xhr);
                window.hideLoading(eleButton[0], '', false);
                return false;
            });
        },
        updateShipping: function (province) {
            $.ajax({
                'method': 'POST',
                'url': route('cart.shipping_method.store'),
                "data": {
                    "province": province
                },
            }).done(function (response) {
                cartFunc.removeError();
                cartFunc.updateInfo(response);
            }).fail( function(xhr, textStatus, errorThrown) {
                cartFunc.showError(xhr);
                window.hideLoading(eleButton[0], '', false);
                return false;
            });
        },
        confirmOrder: function (orderId, paymentMethod, params = {}) {
            $.ajax({
                method: "GET",
                url: route("checkout.complete.store", {
                    orderId,
                    paymentMethod,
                    ...params,
                }),
            })
                .then(function (response) {
                    cartFunc.removeError();
                    window.location.href = route("checkout.complete.show");
                }).fail( function(xhr, textStatus, errorThrown) {
                    cartFunc.showError(xhr);
                    window.hideLoading(eleButton[0], '', false);
                    return false;
                });
        },
        deleteOrder(orderId) {
            if (!orderId) {
                return;
            }

            $.ajax({
                method: "GET",
                url: route("checkout.payment_canceled.store", { orderId }),
            }).then((xhr) => {
                cartFunc.removeError();
                localStorage.removeItem(cartFunc.storageKey);
            }).catch(function (xhr) {
                cartFunc.showError(xhr);
            });
        },
        checkout: function (eleButton) {
            window.setLoading(eleButton[0], 20, 'var(--color-secondary)', false);

            let form = $('#checkout-form');
            // let paymentMethod = $('input[name="payment_method"]:checked').val();
            let paymentMethod = 'cod';

            let formData = form.serializeArray();
            $.ajax({
                method: "POST",
                url: route("checkout.create"),
                data: formData,
            }).then(function (response) {
                cartFunc.removeError();
                localStorage.removeItem(cartFunc.storageKey);
                cartFunc.confirmOrder(response.orderId, paymentMethod);
            }).fail( function(xhr, textStatus, errorThrown) {
                cartFunc.showError(xhr);
                window.hideLoading(eleButton[0], '', false);
                return false;
            });
        },
        storageKey: 'cartItems',
        saveLocalStorage: function (cartItems) {
            let storageValues = [];
            cartItems.forEach(function (item) {
                let obj = {
                    'product_id': item.product.id,
                    'qty': item.qty,
                    'options': {},
                };
                if(item.options.length){
                    obj['options'][item.options[0].id] = item.options[0].values[0].id;
                }

                storageValues.push(obj);
            });

            localStorage.setItem(this.storageKey, JSON.stringify(storageValues));
        },
        newCartFromLocal: function (storageValues) {
            $.ajax({
                method: 'post',
                url: route('cart.items.store-from-local'),
                data: JSON.stringify({
                    'items': storageValues
                }),
                headers: {
                    "Content-Type": "application/json"
                }
            }).done(function (response) {
                cartFunc.removeError();
                if (route().current() === 'cart.index') {
                    window.location.reload();
                } else {
                    cartFunc.renderCartItem(response['items']);
                    cartFunc.updateInfo(response);
                }
            });
        },
        checkLocalStorage: function () {
            let cartItems = Object.values(FleetCart.cart.items);
            if (cartItems.length > 0) {
                this.saveLocalStorage(cartItems);
            } else {
                let storageValues = localStorage.getItem(this.storageKey);
                if (storageValues) {
                    storageValues = JSON.parse(storageValues);

                    if (typeof storageValues == 'object' && storageValues.length) {
                        this.newCartFromLocal(storageValues);
                    }
                }
            }
        },

        init: function () {
            $.ajaxSetup({
                headers: {
                    "X-CSRF-TOKEN": FleetCart.csrfToken,
                },
            });

            this.checkLocalStorage();

            $('.variant-item').on('click', function () {
                cartFunc.variantItemClick($(this))
            })

            $('.btn-add-to-cart').on('click', function () {
                cartFunc.addToCart($(this))
            })

            $('.btn-remove').on('click', function () {
                let itemId = $(this).closest('.main-cart__body--item').data('id');
                cartFunc.removeItem(itemId)
            })

            $('.quantity__form input[type="number"]').on('keypress', function (e) {
                if ([45, 43, 61].indexOf(e.keyCode) !== -1) {// 0, -, +
                    return false;
                }
            }).on('change', function () {
                let val = parseInt($(this).val()) || 0;
                if (val < 1) {
                    $(this).val(1);
                }
            })
            $('#cart-form .quantity__form input[type="number"]').on('change', function () {
                cartFunc.cartItemChange($(this));
            })

            $('#cart-form .quantity__form--button').on('click', function () {
                cartFunc.cartItemChange($(this));
            })

            $('.cart-variant-item').on('change', function () {
                cartFunc.cartItemChange($(this));
            })
            //
            $('.field-province, .field-district').on('change', function () {
                let dataType = $(this).data('type');
                cartFunc.provinceChange(dataType);
            })
            $('.field-province').on('change', function () {
                let province = $(this).val();
                cartFunc.updateShipping(province);
            })
            //
            $('.btn-checkout').on('click', function () {
                let eleButton = $(this);

                window.setLoading(eleButton[0], 20, 'var(--color-secondary)', false);

                let form = $('#checkout-form');
                let valid = typeof $.fn.validate == 'undefined' ? form[0].reportValidity() : form.valid();

                if (!valid) {
                    let firstInput = form.find('input.error, select.error').first();
                    if (firstInput.length > 0) {
                        $('html').animate({
                            scrollTop: firstInput.offset().top - 100
                        }, 200);
                    }

                    window.hideLoading(eleButton[0], '', false);
                    return false;
                }

                cartFunc.checkout(eleButton);
            });
        }
    };
    cartFunc.init();

    $('.checkout__address').select2({});
})